// Intake store (localStorage-backed)
const KEY = "aabb:pending_intake_v1";
export const loadIntake = () => { try { return JSON.parse(localStorage.getItem(KEY)) || { answers: {}, currentStepId: null }; } catch { return { answers: {}, currentStepId: null }; } };
export const saveIntake = (s) => localStorage.setItem(KEY, JSON.stringify(s));
export const clearIntake = () => localStorage.removeItem(KEY);
export const setAnswer = (k, v) => { const s = loadIntake(); s.answers[k] = v; saveIntake(s); };
export const setIntent = (intent) => { const s = loadIntake(); s.answers._intent = intent; saveIntake(s); };
